import { Component } from '@angular/core';

import { Platform, LoadingController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { initChangeDetectorIfExisting } from '@angular/core/src/render3/instructions';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private router: Router
  ) {

    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.inicioApp();
    });
  }
  inicioApp() {
    let rootPage: any;
    try {
      let dato = window.localStorage.getItem("usuario");
      if (dato == null) {
        // window.localStorage.setItem("usuario", "Hola");
        this.router.navigate(['Login']);
       // rootPage = ""
      } else {
        this.router.navigate(['home']);
      //  rootPage = ""
      }
    } catch (error) {

    }
  }

}
